<template>
  <v-layout class="lookup-images-container">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="10" md="9" lg="8" class="py-0">
          <v-card elevation="0">
            <v-card-title>Buscador de imágenes</v-card-title>
            <v-card-subtitle
              >Busque imágenes de productos ingresando una parte del
              nombre</v-card-subtitle
            >
            <v-card-text>
              <v-text-field
                outlined
                dense
                label="Nombre del producto"
                hide-details
                v-model="lookupName"
                class="mb-4"
              />
              <v-skeleton-loader type="paragraph" v-if="loading" />
              <v-row v-else>
                <v-col
                  cols="2"
                  style="position: relative"
                  v-for="item of items"
                  :key="item.id"
                >
                  <v-img :src="`${uploadsPath}/${$thumb(item.picture)}`" />
                  <a
                    :href="`${uploadsPath}/${item.picture}`"
                    download
                    class="download"
                    ><v-btn fab x-small depressed color="info"
                      ><v-icon>mdi-download</v-icon></v-btn
                    ></a
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { IItem } from '../../../interfaces/IItem';
  import ItemsService from '../../../api/services/items.service';
  import { vueData } from '../../../VueData';
  import { Globals } from '../../../modules/Globals';
  import { debounce } from '../../../utils';

  @Component
  export default class ItemPicturesLookup extends Vue {
    itemsService = new ItemsService();
    lookupName: string = null;
    items: IItem[] = [];
    loading = false;
    uploadsPath = Globals.uploadsPath;
    lookupItems: () => void;

    async created() {
      this.lookupItems = debounce(async () => {
        if (!this.lookupName) {
          this.items = [];
          return;
        }

        this.loading = true;
        this.items = [];

        try {
          const items = await this.itemsService.getAllByName(this.lookupName);
          this.items = items.filter((i) => !!i.picture);
        } catch (e) {
          vueData.serverError(e);
        } finally {
          this.loading = false;
        }
      }, 250);
    }

    @Watch('lookupName')
    async onNameChanged(newName) {
      if (!newName || newName.length >= 3) this.lookupItems();
    }

    download() {}
  }
</script>
